export const CAPTCHA_REQUIRED = 'CAPTCHA_REQUIRED';
export const INVALID_CAPTCHA = 'INVALID_CAPTCHA';

export const CAPTCHA_MAX_ATTEMPTS = 2;
export const CAPTCHA_CONFIRM_MESSAGE = 'Please confirm you are not a robot.';
export const CAPTCHA_FAILED_MESSAGE = 'Captcha verification failed. Try again.';

export const CAPTCHA_ERRORS = [
    CAPTCHA_REQUIRED,
    INVALID_CAPTCHA,
];
